import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Moods",
  "description": "",
  "published": "2006-09-24T00:00:00.000Z",
  "redirect_from": ["/blog/moods/swizec/382"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`At small hours of the morning you are torn between the shadows of blue and the darkness of bright red. You cannot decide whether to perform true works of art or to go do the work your employer is making you do at gun point. Both are equally sinister and both will leave you torn and shaken to the bone.`}</p>
    <p>{`But one you can do fairly easily by simply running a few applications, the other requires you to magically produce light from an unworking desklamp and an oddly positioned useless main lamp. What do you do? Sit in the dark and wallow in self pity of course.`}</p>
    <p>{`Until an amazing comic book from an awesome artist comes along out of the drawer and captures your dwindling attention. It jumps at you with all it's glory and when you learn the one who makes it also the author of all that awesome music you've been listening to for weeks you are warmly surprised and happy.`}</p>
    <p>{`Then when you flip the pages around you notice amazing guest comics from people like Maxwell Atoms and other such geniouses. The book really is worthy of all your love.`}</p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/kscan_0177.png",
        "alt": "The Book Of Deady"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      